/// <amd-module name="Core/Medius.Core.Web/Scripts/lib/messageLogging/messageLogger"/>
import { trackTrace } from "Core/Medius.Core.Web/Scripts/appInsights";

export function logMessage(message: string, type: string) {  
    trackTrace({
        message: message,
        properties: { type: type }
    });
}

export function logFromError(error: Error) { 
    trackTrace({  
        message: `${error.name}: ${error.message}`
    });
}

export function startLogging() {  
    function logFromOnError(message: string, filename?: string, lineNumber?: number, columnNumber?: number, error?: Error) {  
        if (error) {  
            trackTrace({  
                message: `${message} ${filename}:${lineNumber}:${columnNumber}\n${error.name}: ${error.message}`,  
                properties: {  
                    filename: filename,  
                    lineNumber: lineNumber,  
                    columnNumber: columnNumber,  
                    errorName: error.name,  
                    errorMessage: error.message  
                }  
            });  
        } else {  
            trackTrace({  
                message: `${message} ${filename}:${lineNumber}:${columnNumber}`,  
                properties: {  
                    filename: filename,  
                    lineNumber: lineNumber,  
                    columnNumber: columnNumber  
                }  
            });
        }
    }
  
    function onUnhandledPromiseRejection(event: any) {  
        trackTrace({  
            message: `Unhandled rejection: ${event.reason.message}`,  
            properties: {  
                reason: event.reason.message
            }  
        });  
    }
  
    window.addEventListener("unhandledrejection", onUnhandledPromiseRejection);  
    (window as any).onerror = logFromOnError;
}